import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AboutCousal from "./cousalabout.jsx";

export const About = (props) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div id="About" className="about-section py-5">
      <div className="container-fluid px-3 px-md-5">
        <div className="row align-items-center">
          {/* Left Image */}
          <div
            className="col-12 col-md-6 mb-4 mb-md-0 text-center"
            data-aos="fade-right"
          >
           <AboutCousal/>
          </div>

          {/* Right Text */}
          <div className="col-12 col-md-6" data-aos="fade-left">
            <div className="about-text">
              <h2 className="mb-3">About Us</h2>
              <p>{props.data ? props.data.paragraph1 : "Loading..."}</p>
              <p>{props.data ? props.data.paragraph2 : "Loading..."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
